module.exports = __webpack_public_path__ + "static/media/Refresh.b3cc9a7d.svg";